export enum MitigationPlanFrequencySource {
  RecommendationFrequency,
  ThicknessRemainingHalfLife,
  CriticalityEstimatedHalfLife,
  FactoredRemainingLife,
  CmlDueDate,
  Overridden,
  LastActivePlan,
  MaxInspectionFrequency
}
